import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";
import { downloadFile, getContentTypeByMime } from "shared/util/functions/download/DownloadFunctions";
import { formatarData } from "shared/util/functions/formatacoesDeValores/FormatarValores";

export const useGetRelatorioProcessoJudicial = (processoId: number) => {
  const onError = () => {
    toast.error("Erro ao gerar o relatório");
  };

  const onSuccess = (response: string) => {
    toast.success("Relatório emitido com sucesso");
    downloadFile(
      response,
      `Relatório Processo Judicial ${formatarData(new Date())}`,
      getContentTypeByMime("pdf"),
      true
    );
  };

  return useFetch<number>({
    key: ["relatorio-processo-judicial", processoId],
    url: `${api.processosJudiciais.getRelatorioProcessoJudicial}/${processoId}`,
    onError,
    onSuccess,
    enabled: processoId !== null && processoId !== undefined,
  });
};
